import ProjectFinalApprovalPage from "../../shared/project-final-approval/ProjectFinalApprovalPage";

const ManagementProjectFinalApprovalPage = () => (
  <ProjectFinalApprovalPage source="Management" />
);

export default ManagementProjectFinalApprovalPage;
